import React from 'react';
import classnames from 'classnames';

import { GenericButton } from '../button';
import PropTypes from 'prop-types';
import Icon from 'shared/components/icon/icon';
import withTooltip, { adaptShowStatePropsToClassName } from 'shared/components/with-tooltip/with-tooltip';

import styles from './icon.styl';


export default class IconButton extends React.Component {

  static propTypes = {
    Button: PropTypes.func,
    name: PropTypes.string,
    size: PropTypes.number,
    label: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.string,
    dataHook: PropTypes.string,
    iconClassName: PropTypes.string,
  };

  static defaultProps = {
    Button: GenericButton,
  };

  get label() {
    const { label, children } = this.props;
    const text = _.isUndefined(label) ? children : label;

    if (!text) {
      return null;
    }

    return (
      <span className={styles.text}>
        {text}
      </span>
    );
  }

  render() {
    const { Button, name, size, iconClassName, className, dataHook, ariaLabel } = this.props;
    const props = _.omit(this.props, 'intl', 'styles', 'settings', ..._.keys(IconButton.propTypes));

    const label = this.label;

    const classNames = classnames({
      [styles.generic]: Button === GenericButton,
    }, className);

    return (
      <Button {...props}
              ariaLabel={ariaLabel}
              dataHook={dataHook}
              className={classNames}>
        <Icon name={name}
              size={size}
              className={classnames(styles.icon, iconClassName)} />
        {label}
      </Button>
    );
  }
}

export const TooltipIconButton = withTooltip(adaptShowStatePropsToClassName(IconButton));



// WEBPACK FOOTER //
// ./src/shared/components/button/icon/icon.js